import AcquisitionIntelInterface from './components/AcquisitionIntelInterface';

function App() {
  return <AcquisitionIntelInterface />;
}

export default App;
